// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__taPvc"};